<template>
  <v-dialog fullscreen v-model="visible" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Produto: {{ reference }} - {{ name }}
      </v-card-title>

      <v-img
        :src="photo"
        alt=""
        max-width="1344"
        contain
        class="justify-center align-center mx-auto"
        :aspect-ratio="16 / 9"
      ></v-img>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue" text @click="closeDialog"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    reference: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    photo: {
      type: String,
      default: "",
    },
    closeDialog: Function,
  },
};
</script>
